type PhotoPlaceholderProps = {
  label: string;
  className?: string;
};

/**
 * Stands in for real project photography until it exists. Intentionally
 * unmistakable as a placeholder (see .photo-placeholder in global.css) so it
 * can never read as a finished photo or be shipped as fabricated evidence.
 */
export function PhotoPlaceholder({ label, className }: PhotoPlaceholderProps) {
  return (
    <div className={`photo-placeholder ${className ?? ''}`} role="img" aria-label={label}>
      {label}
    </div>
  );
}
